export default __webpack_public_path__ + "static/media/exit _icon.d08faabe.svg";